import toast from "react-hot-toast";

const { clientAPI } = require("../client");

// Đơn xin đi muộn (05/11/2026) - web HCNS

const showError = (error) => {
  const errorMessages = error?.response?.data?.errors?.map(
    (err) => err.message
  ) || [
    error?.response?.data?.message ||
      error?.response?.statusText ||
      error?.message ||
      "Có lỗi xảy ra",
  ];
  errorMessages.forEach((message) => toast.error(`${message}`));
};

const call = async (method, url, data) => {
  try {
    return await clientAPI(method, url, data);
  } catch (error) {
    console.error("lateCheckinRequest error:", error);
    showError(error);
    throw error;
  }
};

/** Bỏ tham số rỗng rồi dựng query string */
const toQuery = (params = {}) =>
  new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== "" && v !== null && v !== undefined
      )
    )
  ).toString();

export const lateCheckinCall = {
  list: (params) => call("get", `/lateCheckinRequest?${toQuery(params)}`),
  handle: (id, data) => call("put", `/lateCheckinRequest/${id}/handle`, data),
  create: (data) => call("post", "/lateCheckinRequest", data),
  update: (id, data) => call("put", `/lateCheckinRequest/${id}`, data),
  remove: (id) => call("delete", `/lateCheckinRequest/${id}`),
  // Xuất DS nhân viên được đi muộn theo bộ lọc đang chọn (BE trả JSON, web dựng Excel)
  export: (params) => call("get", `/lateCheckinRequest/export?${toQuery(params)}`),
};
